/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Butterfly(props) {
	const group = useRef();
	const { nodes, materials } = useGLTF("models/Logos/Butterfly.glb");
	return (
		<group ref={group} {...props} dispose={null}>
			<mesh
				geometry={nodes.Logo_Butterfly.geometry}
				material={materials["Material.001"]}
				position={[-0.32, 2.64, 0]}
				rotation={[1.49, 0, 0]}
				scale={68.42}
			/>
		</group>
	);
}

useGLTF.preload("/Butterfly.glb");
